<template>
  <div class="header" style="width: 100%;position: relative;" :class="[ headerContainer ]">
    <div v-if="mobileShow" style="position: absolute ;width:100%; height:48px;bottom:0;left:0;background: #122266;"></div>
    <div class="mobile_header">
      <!-- logo搜索 -->
      <div class="home_header">
        <!-- old -->
        <!-- <div class="home_header_title">
          <div class="home_title">
            <div class="home_logo">
              <img class="home_title_logo" :src="$path + siteData.logo" alt @click="toindex"/>
              <img class="home_title_marshalling" src="../assets/home/marshalling.png" alt="">
            </div>
            <div class="common-ele">
              <el-input
                class="new_input"
                :placeholder="placeholder"
                v-model="search"
                @input="searchInput"
                @keyup.enter.native="searchChange"
              >
                <div class="input_search_btn" slot="append" @click="searchChange">搜索</div>
              </el-input>
              <div style="width:492px" class="home_search">
                <span style="margin-left: 0px !important; color: #1E203C; font-weight: 400;"
                  >热门搜索：</span
                >
                <span
                  class="home_search_text"
                  v-for="(item, index) in keylist"
                  :key="index"
                  >
                    <a :href="item.urlLink" :target="item.type === 345 || item.type === 7 ? '_blank' : '_self'">{{ item.name }}</a>
                  </span>
              </div>
            </div>
          </div>
        </div> -->
        <div class="new-home_header_title">
          <div class="new-home-tit-left">
            <div class="new-tit-left-logo" @click="toindex">
              <img class="new-tit-left-img" :src="$path + siteData.logo" alt="">
            </div>
            <div class="new-tit-left-other">
              <img class="new-tit-left-img" src="../assets/home/marshalling.png" alt="">
            </div>
          </div>
          <div class="new-home-tit-mid">
            <div class="common-ele">
              <el-input
                class="new_input"
                :placeholder="placeholder"
                v-model="search"
                @input="searchInput"
                @keyup.enter.native="searchChange"
              >
                <div class="input_search_btn" slot="append" @click="searchChange">搜索</div>
              </el-input>
              <div style="width:423px" class="home_search">
                <span style="margin-left: 0px !important; color: #1E203C; font-weight: 400;"
                  >热门搜索：</span
                >
                <span
                  class="home_search_text"
                  v-for="(item, index) in keylist"
                  :key="index"
                  >
                    <a :href="item.urlLink" :target="item.type === 345 || item.type === 7 ? '_blank' : '_self'">{{ item.name }}</a>
                  </span>
              </div>
            </div>
          </div>
          <div class="new-home-tit-right">
            <div class="new-tit-right-phone-img">
              <img src="../assets/home/mobile/phone-icon.png" alt="">
            </div>
            <div class="new-home-tit-right-ctn">
              <div class="new-home-tit-right-text">24小时全国服务热线</div>
              <div class="new-home-tit-right-phone">400-800-1252</div>
            </div>
          </div>
        </div>
      </div>
      <div class="home_header_bottom">
        <div class="home_title_center" style="width: 1200px">
            <Fragment   v-for="(item, index) in menuList"
                    :key="index">
              <span
                  v-if="item.text!=='实用工具'"
                   style="height: 20px"
                   class="menuStyle_box"
                   @click="navto(item)">
                  <div >
                    <span class="home_title_text" @mouseenter="handleNavEnter(index)" >
                      <span> {{ item.text }}</span>
                      <img v-if="!isNavMenuShow && index === 1" src="../assets/home/menu_down.png" alt="">
                      <img v-if="isNavMenuShow && index === 1" src="../assets/home/menu_down_color.png" alt="">
                      <img v-if="!isCertMenuShow && index === 5" src="../assets/home/menu_down.png" alt="">
                      <img v-if="isCertMenuShow && index === 5" src="../assets/home/menu_down_color.png" alt="">
                    </span>
                    <div :class="isNavMenuShow && index === currentMenu ? 'menuStyle_hover menuStyle' : 'menuStyle'" @mouseleave="handleNavLeave(index)">
                      <img class="menuStyle_icon" src="../assets/home/triangle.png" alt="">
                      <div  v-if="index === 1" style="padding-bottom: 12px;">
                        <div class="product_service_box" v-for="v in item.children" :key="v.id">
                            <!-- 行业解决方案 -->
                            <div v-if="v.name === '行业解决方案'" style="margin-top: 30px;">
                              <div class="title_name">
                                <img src="../assets/home/solution_icon.png" alt="">
                                <div>行业解决方案</div>
                              </div>
                              <div class="solution_nav">
                                <span v-for="(it, i) in v.children" :key="i" :command="it">
                                  <a :href="'/detection?id='+it.id+'&name='+it.name" class="primary_title">{{ it.name }}</a>
                                  <a v-for="(child, key) in it.children.slice(0,5)" :href="'/detection?id='+it.id+'&name='+it.name+'&twoLeve='+child.id" :key="key">{{ child.name }}</a>
                                  <a v-if="it.children.length>5" :href="'/detection?id='+it.id+'&name='+it.name">{{'更多'}}</a>
                                </span>
                              </div>
                            </div>
                            <!-- 业务服务 -->
                            <div v-if="v.name === '业务服务'" style="display: flex;margin-top: 30px;">
                              <div class="title_name">
                                <img src="../assets/home/business_icon.png" alt="">
                                <span>业务服务</span>
                              </div>
                              <div class="business_nav" style="margin-left: 66px;">
                                <span v-for="(it, i) in v.children" :key="i" :command="it">
                                  <a :href="'/services?columnId='+it.id+'&name='+it.name" class="primary_title">{{ it.name }}</a>
                                </span>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div :class="isCertMenuShow && index === currentMenu ? 'menuStyle_hover menuStyle' : 'menuStyle'"  @mouseleave="handleNavLeave(index)" style="width: 170px;left: 615px;">
                      <img class="menuStyle_icon" src="../assets/home/triangle.png" alt="" style="left: 75px;">
                      <div class="nav" v-if="index === 5">
                          <div v-for="(item,index) in navs" :key="index" @click="toCertification(item)">
                            {{ item.name }}
                          </div>
                      </div>
                    </div>
                  </div>
            </span>
            </Fragment>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div>
        <div class="mobile_nav" style=" position: fixed; z-index: 9999999;" >
            <div class="m_logo" @click="toindex">
                <img src="../assets/home/mobile/logo_mb.png" alt="">
            </div>
            <div class="phone">
              <div class="phone-icon">
                <img src="../assets/home/mobile/phone-icon.png" alt="">
              </div>
              <div class="phone-number">
                <a href="tel:400-800-1252">400-800-1252</a>
              </div>
            </div>
            <ul class="m_menu">
                <li @click="handleSearch">
                    <img src="../assets/home/mobile/search@2x.png" alt="">
                </li>
                <li>
                    <img  @click="handleMenuClose()" v-if="isShowClose"  src="../assets/home/mobile/menu_close@2x.png" alt="">
                    <img  @click="handleMenu()"  v-else src="../assets/home/mobile/menu@2x.png" alt="">
                </li>
            </ul>
        </div>
        <div class="mobile_nav">
            <div class="m_logo" @click="toindex">
                <img src="../assets/home/mobile/logo@2x.png" alt="">
            </div>
            <ul class="m_menu">
                <li @click="handleSearch">
                    <img src="../assets/home/mobile/search@2x.png" alt="">
                </li>
                <li >
                    <img  @click="handleMenuClose()" v-if="isShowClose"  src="../assets/home/mobile/menu_close@2x.png" alt="">
                    <img  @click="handleMenu()"  v-else src="../assets/home/mobile/menu@2x.png" alt="">
                </li>
            </ul>

        </div>
    </div>
  </div>
</template>

<script>
    (function() {
      // 22222222
        // if (document.documentElement.clientWidth <=960) {
        // var hm = document.createElement("script");
        // hm.src = "https://hm.baidu.com/hm.js?7c776de221151da059e4b4bd67d03cbb";
        // var s = document.getElementsByTagName("script")[0]; 
        // s.parentNode.insertBefore(hm, s);
        // }
    })();
import {Fragment} from 'vue-fragment'
import { mapState, mapMutations } from 'vuex'
export default {
    components:{
        Fragment
    },
  props: {
    phoneHome: {
      type: Boolean,
      default: false,
    },
    pageFlag: {
       type: String,
       default: '',
    },
    pageStatus: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(['screenWidth','serviceMenuList','productTypeList']),
    mobileShow() {
      if (this.screenWidth < 1000) {
        return false
      } else {
        return true
      }
    },
      // eslint-disable-next-line vue/return-in-computed-property
    headerContainer() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "mheaderContainer";
        case "sm":
          return "mheaderContainer";
        case "md":
          return "pcheaderContainer";
        case "lg":
          return "pcheaderContainer";
        case "xl":
          return "pcheaderContainer";
      }
    }
  },
    data() {
    return {
      imgArr: [require('../assets/home/mobile/_up@2x.png'), require('../assets/home/mobile/_down@2x.png')],
      beforeUrl:'',
      search: "",
      placeholder: "请输入您想要的检测服务关键词",
      isNavMenuShow: false,
      isCertMenuShow: false,
      isMenuShow: false,
      isShowClose:false,
      currentMenu: 0,
      currentMenuChild: 0,
      isMenuChildShow: false,
      isMenuChildShow2: false,
      currentMenuChild2: 0,
      urlLink: '',
      siteData: {},
      busService: [],
      menuList: [
        {
          id: "1",
          text: "首页",
          path: "/home",
          hoverStatus: false,
        },
        {
          id: "2",
          text: "产品服务",
          path: "",
          hoverStatus: true,
          children: [
            {
              id: '2-1',
              name: '行业解决方案',
              children: []
            },
            {
              id: '2-2',
              name: '业务服务',
              children: []
            }
            // {
            //   id: '2-3',
            //   name: '热门套餐',
            //   children: []
            // }
          ]
        },
        {
          id: "5",
          text: "国联动态",
          path: "/enterprise",
          hoverStatus: false,
        },
        {
          id: "5",
          text: "国联党建",
          path: "/partyBuilding",
          hoverStatus: false
        },
        {
          id: "5",
          text: "国联科普教育基地",
          path: "/brand",
          hoverStatus: false
        },
        {
          id: "7",
          text: "认证中心",
          path: "",
          hoverStatus: true
        },
        {
          id: "4",
          text: "关于国联",
          path: "/aboutMe",
          hoverStatus: false,
        },
        {
          id: "5",
          text: "联系我们",
          path: "/contact",
          hoverStatus: true
        },
        {
            id: "7",
            text: "订单报告/证书查询",
            path: "/queryOrderReportCert",
            isJump:true,
            hoverStatus: true
        },
        // {
        //     id: "8",
        //     text: "报告验证",
        //     path: "http://glpc.xaunqd.com/verification/index.html",
        //     isJump:true,
        //     hoverStatus: true
        // },
        // {
        //     id: "7",
        //     text: "食品安全管理人员",
        //     path: "/foodSafetyUserCertificate",
        //     isJump:true,
        //     hoverStatus: true
        // }
        // {
        //       id: "6",
        //       text: "实用工具",
        //       path: "",
        //       hoverStatus: true,
        //       children: [
        //           {
        //               id: "6-1",
        //               name: '报告验证',
        //               path: "http://glpc.xaunqd.com/verification/index.html",
        //               flag: true,
        //               isJump:true,
        //               hoverStatus: true
        //           },
        //           {
        //               id: "10402",
        //               name: "政策解读",
        //               path: "/utilitytools",
        //               isJump:true,
        //               hoverStatus: true
        //           },
        //           {
        //               id: "10403",
        //               name: "资料下载",
        //               path: "/utilitytools",
        //               isJump:true,
        //               hoverStatus: true
        //           },
        //           {
        //               id: "10401",
        //               name: "质检科普",
        //               path: "/utilitytools",
        //               isJump:true,
        //               hoverStatus: true
        //           }
        //       ]
        //  }

      ],
      keylist: [],
      navs:[]
    };
  },
  created() {
     this.initData()
     this.getcolumnList();
    if (this.$route.path == "/search") {
      if (window.localStorage.getItem("searchVal")) {
        this.search = window.localStorage.getItem("searchVal");
      }
    }
    if (window.localStorage.getItem("siteData")) {
      this.siteData = JSON.parse(window.localStorage.getItem("siteData"));
    } else {
      this.$api.iotHome
        .getSite({
          siteType: "0",
          type: "0",
        })
        .then((res) => {
          if (res.data.success == true) {
            this.siteData = res.data.data;
          }
        });
    }
    this.$api.iotHome
      .getKeywords({
        siteId: "0",
      })
      .then((res) => {
        if (res.data.success == true) {
          this.keylist = res.data.data.map(item => {
            let urlLink = ''
             switch (item.type) {
              case 1:
                 urlLink = `/detectionDetail?id=${item.jumpInfo}`
                 break
              case 2:
                urlLink = `/detection?id=${item.jumpInfo}`
                break
              case 3:
                urlLink = `/services?columnId=${item.jumpInfo}`
                break
              case 4:
                urlLink = `/enterpriseDetail?id=${item.jumpInfo}`
                break
              case 5:
                urlLink = `/toolsDetail?id=${item.jumpInfo}`
                break
              case 6:
                urlLink = `/toolsDetail?id=${item.jumpInfo}`
                break
              case 7:
                urlLink = item.jumpInfo
                break
              case 345:
                urlLink = item.jumpInfo
                break
              default:
                urlLink = item.jumpInfo
            }
            return {
              ...item,
              urlLink: urlLink
            }
          })
        }
      });

      // 业务服务
      setTimeout(() => {
        if(this.serviceMenuList) {
          this.menuList[1].children[1].children = this.serviceMenuList;
        } else {
          this.$api.iotHome
          .getServiceList({
            type: 1
          })
          .then(res => {
            if (res.data.success == true) {
              this.$store.commit("changeServiceMenuList", res.data.data);
              this.menuList[1].children[1].children = res.data.data;
            }
          })
        }
      }, 200);
      setTimeout(() => {
        if(this.productTypeList || window.sessionStorage.getItem("productTypeList")) {
          let productTypeList = null
          if(this.productTypeList) {
            productTypeList = this.productTypeList
          } else {
            productTypeList = JSON.parse(window.sessionStorage.getItem("productTypeList"))
          }
          for (let i = 0; i < productTypeList.length; i++) {
            productTypeList[i].path = "/detection";
          }
          this.menuList[1].children[0].children = productTypeList;
        } else {
          this.$api.iotHome
            .typelist()
            .then((res) => {
              if (res.data.success == true) {
                this.$store.commit("changeProductTypeList", res.data.data);
                window.sessionStorage.setItem("productTypeList", JSON.stringify(res.data.data));
                window.localStorage.setItem("detaList", JSON.stringify(res.data.data));
                for (let i = 0; i < res.data.data.length; i++) {
                  res.data.data[i].path = "/detection";
                }
                this.menuList[1].children[0].children = res.data.data;
              }
            });
        }
      }, 500);
   
      // 热门服务
      // this.$api.iotHome
      //   .hotProductlist({
      //       rows: 20,
      //       page: 1,
      //       hotFlag: 1,
      //       siteId: "0",
      //   })
      //   .then((res) => {
      //       if (res.data.success == true) {
      //               if (res.data.data.content.length<20){
      //                   res.data.data.content.push({
      //                       relationId:'999999999999999999999999999',
      //                        name:'更多>>'
      //                 })
      //               }else {
      //                   res.data.data.content[19]={
      //                       relationId:'999999999999999999999999999',
      //                       name:'更多>>'
      //                   }
      //               }
      //           this.menuList[1].children[2].children = res.data.data.content;

      //       }
      //   });
  },
    watch:{
        isMenuShow: function(newVal, oldVal) {
         // var mobile_nav  = document.querySelector(".mobile_nav");
            if (newVal) {
             this.setMaskHeight()
            }
          // console.log(body.offsetH)
        }
    },
    methods: {
    changetetle(data) {
      document.title = data
    },

     setMaskHeight(){

    },
    initData(){
        if (this.pageFlag === 'menus'){
            this.isShowClose =true
        }
    },
    handleMenuChild(index) {
      this.isMenuChildShow = !this.isMenuChildShow
      this.currentMenuChild = index
      this.setMaskHeight()
    },
    handleMenuChild2(index,item) {
        if (item.isJump){
            this.jumpTools(item)
        }
      this.isMenuChildShow2 = !this.isMenuChildShow2
      this.currentMenuChild2 = index
        this.setMaskHeight()
    },
    jumpTools(data){

        window.localStorage.setItem("defaultActive", data.id);
        if (data.path === '/utilitytools') {
            this.$router.push({
                path: data.path,
                query: {
                    columnId: data.id
                },
            });
        } else {
            if (data.path.indexOf('http') > -1) {
                if (document.documentElement.clientWidth < 900) {
                    if (data.flag) {
                        this.$notify({
                            message: '请在电脑端进行查询',
                            // position: 'top-left',
                            type: 'warning',
                            offset: 100
                        })
                    } else {
                        window.open(data.path)
                    }
                } else {
                    window.open(data.path)
                }
            } else {
                if (data.path == this.$route.path + "/") {
                    this.$router.go(0);
                } else {
                    this.$router.push({
                        path: data.path,
                        query: {
                            id: data.id
                        },
                    });
                }
            }
        }

    },
    handleMenu(event) {

        this.$router.push({
            path: '/menus'
        })
      //   if (this.phoneHome){
      //       this.$router.go(-1)
      //       // if (this.pageFlag === 'menus') {
      //       //      this.$router.go(-1)
      //       // }else {
      //       //     this.$router.push({
      //       //         path: '/menus'
      //       //     })
      //       // }
      //   } else {
      //         this.$router.push({
      //               path: '/menus'
      //         })
      //
      //   }
      // this.isMenuShow =  !this.isMenuShow
    },
     handleMenuClose(event) {
         window.history.back()
            // this.$router.go(-1)
     },
        // 移动端搜索跳转
        handleSearch() {
            if (this.phoneHome){
                if (this.pageFlag === 'search') {
                    window.history.back()
                    // this.$router.go(-1)
                }else {
                    this.$router.push({
                        path: '/search'
                    })
                }
            } else {
                this.$router.push({
                    path: '/search'
                })
            }
        },
    getcolumnList() {
      this.$api.iotHome
        .columnList({
          parentId: "108",
          siteId: "0",
        })
        .then((res) => {
          if (res.data.success) {
            this.navs = res.data.data[0].children;
            if(this.navs.length > 0) {
              const index10803 = this.navs.findIndex(nav => nav.id === '10803')
              const index10806 = this.navs.findIndex(nav => nav.id === '10806')
              if (index10803 !== -1 && index10806 !== -1) {
                const item10806 = this.navs.splice(index10806, 1)[0] // 从原位置移除 10806
                this.navs.splice(index10803, 0, item10806) // 将 10806 插入到 10803 后面
              }
            }
            window.localStorage.setItem(
              "certification_menu_data_new",
              JSON.stringify(this.navs)
            )
          }
        })
    },
    // 搜索
    searchChange() {
      document.title = this.search+"搜索|国联质检"
      if (this.search != "") {
        // if (this.$route.path != "/search") {
          this.$router.push({
            path: "/search",
            query: {
              search: this.search,
            },
          });
          this.$emit("changeSearch", this.search);
        // } else {
        //   this.$emit("changeSearch", this.search);
        // }
      } else {
        this.placeholder = "搜索结果不能为空";
      }
    },
    // searchClick(val) {
    //   window.localStorage.setItem("searchVal", val);
    //   this.search = val;
    //   this.searchChange();
    // },
    searchInput(val) {
      window.localStorage.setItem("searchVal", val);
      this.search = val;
    },
    // 导航的路由跳转
    navto(data) {
      // this.$store.commit("changeActive", "1-1-1");
      if(data.id == 8) {
        window.open(data.path)
        return 
      }
      this.$router.push({
        path: data.path,
      });
    },
    navto2(data) {
      window.localStorage.setItem("defaultActive", data.id);
      if (data.id == "10801") {
        data.path = "/AC2";
        window.localStorage.setItem("new_id", "1080101");
        this.$router.push({
          path: "/AC2",
        });
      }
      if (data.id == "10802") {
        data.path = "/AC2";
        window.localStorage.setItem("new_id", "1080201");
        this.$router.push({
          path: "/AC2",
        });
      }
      if (data.id == "10803") {
        data.path = "/AC2";
        window.localStorage.setItem("new_id", '1080301');
        this.$router.push({
          path: "/AC2",
        });
      }
      if (data.id == "10804") {
        data.path = "/AC2";
        window.localStorage.setItem("new_id", data.id);
        this.$router.push({
          path: "/AC2",
        });
      }
      if (data.id == "10805") {
        data.path = "/AC2";
        window.localStorage.setItem("new_id", data.id);
        this.$router.push({
          path: "/AC2",
        });
      }
      if (data.path != this.$route.path) {
        if (data.path == this.$route.path + "/") {
          this.$router.go(0);
        } else {
          this.$router.push({
            path: data.path,
            query: {
              status: "aaa",
            },
          });
        }
      } else {
        this.$router.go(0);
      }
    },
    handleNavEnter(index) {
      if (index === 1) {
        this.isNavMenuShow = true
        this.currentMenu = index
      }
      if (index === 5) {
        this.isCertMenuShow = true
        this.currentMenu = index
      }
    },
    handleNavLeave(index) {
      if (index === 1) {
        this.isNavMenuShow = false
        this.currentMenu = index
      }
      if (index === 5) {
        this.isCertMenuShow = false
        this.currentMenu = index
      }
    },
    toindex(){
      this.$router.push({
        path: "/"
      })
    },
    // 认证中心跳转
    toCertification(item){
      let url = null
      if(item.id === '10802'){
        url = `/detection?id=24&name=认证服务`
      } else{
        url = `/certification?id=${item.id}`
      }
      window.open(url, '_self')
    }
  },
};
</script>
<style lang="scss">
  @import "../style/element-ui";
  // 产品服务
  .product_service_box {
    margin-left: 37px;
    margin-right: 37px;
    .title_name {
      display: flex;
      align-items: flex-start;
      font-size: 22px;
      font-weight: bold;
      div,span {
        margin-left: 18px;
        line-height: 1;
      }
      div {
        flex:1;
        padding-bottom: 13px;
        border-bottom: 1px solid #CFD3DC;
      }
    }
    .solution_nav {
      overflow: hidden;
      margin-left: 42px;
      span {
        width: 142px;
        margin-right: 10px;
        display: inline-block;
        margin-top: 25px;
        vertical-align: top;
        .primary_title {
          font-size: 16px;
          font-weight: bold;
          color: #282B45;
          line-height: 1;
          padding-top: 0px;
          margin-bottom: 5px;
        }
        .primary_title:hover{
          color: #282B45;
        }
      }
      a {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #777995;
        padding-top: 10px;
        line-height: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      a:hover {
        color: #4064FF;
      }
    }
    .business_nav {
      flex: 1;
      font-size: 0;
      span {
        display: inline-block;
        width: 100px;
        height:22px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
      a {
        display: inline-block;
        font-size: 16px;
        height:22px;
        color: #282B45;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      a:hover {
        color: #4064FF;
      }
    }
  }
  .menuStyle {
    max-height: 500px !important;
    overflow-y: auto !important;
  }
</style>
<style scoped>
/* 手机端 */
@media all and (max-width: 960px) {
    .mobile_nav{
      display: flex!important;
    }
    .mobile_header{
      display: none!important;
    }
}
/* PC端 */
@media all and (min-width: 960px) {
    .mobile_nav{
      display: none!important;
    }
     .mobile_header{
      display: block!important;
    }
}
[v-clock] {
    display: none;
}
.home_header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}

.home_header_title {
  margin: 0 auto;
  width: 1200px;
}

.home_title {
  margin-bottom: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.unqd-mask{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    min-height: 100vh;
    z-index: 999999999999999;
    background: RGBA(0, 0, 0, .4);

}
.home_logo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.home_title_logo {
  cursor: pointer;
  margin-right: 0px;
}
.home_title_marshalling {
  margin-right: 150px;
}

.home_title_center {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.home_title_text {
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  font-family: PingFang SC;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.home_title_text img {
  width: 9px;
  height: 5px;
  margin-left: 8px;
}

.home_header_bottom {
  width: 1200px;
  height: 48px;
  background: #122266;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
  border-radius: 4px 4px 0 0;
}

.input_search_btn {
  width: 64px;
  text-align: center;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  font-family: PingFang SC;
}
.home_title_center {
  position: relative;
}
.menuStyle {
  width: 100%;
  /* height: 420px; */
  background: #fff;
  top: 34px;
  left: 0;
  z-index: 999;
  position: absolute;
  display: none;
  border-radius: 0 0 5px 5px;
  border: 1px solid #cfd3dc;
  border-top: 0;
  opacity: 0.95;
}
.nav div{
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #282B45;
  cursor: pointer;
}
.menuStyle_hover {
  display: block;
}
.menuStyle_icon {
  position: absolute;
  top: -1px;
  left: 134px;
}
.menu_children_box {
  display: flex;
  justify-content: space-around;
}
.menu_children {
  text-align: left;
  margin-top: 24px;
  margin-bottom: 24px;
}
.menu_children h4 {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #1E203C;
  opacity: 0.95;
  margin-bottom: 20px;
}
.menu_children ul {
  border-top: 1px solid #E1E3EC;
  height: 330px;
  padding-top: 20px;
  display: flex;
  flex-flow: wrap;
  flex-direction: column;
  text-align: left;
}
.menu_children ul > li {
  width: 200px;
}
.menu_children ul > li a {
  line-height: 30px;
  font-size: 14px;
  font-family: PingFang S;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
}
.menu_children ul > li a:hover {
  color: #122266;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  text-align: justify;
}

.el-input-group__append,
.el-input-group__prepend {
  background: #0076c6;
  border: 0.5px solid #0076c6 !important;
  padding: 0px !important;
}

.home_title_phone {
  /* width: 241px; */
  height: 78px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.home_title_phone_img {
  width: 55px;
  height: 54px;
  margin-right: 15px;
}

.home_title_phone_text {
  /* width: 176px; */
  height: 54px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.home_title_phone_text > p {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
}

/* .home_title_phone_num {
  font-size: 25px !important;
  font-weight: 700 !important;
  color: #ffb331 !important;
} */

.home_search {
  padding-top: 9px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  color: #777995;
  font-family: PingFang SC;

}
.home_search_text {
  margin-right: 10px;
  /* font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  color: #1E203C;
  font-family: PingFangSC, PingFangSC-Regular; */
}
.home_search_text:nth-child(7n) {
  margin-right: 0;
}
.home_search_text a {
  color: #1E203C;
}
/* .home_search_text:hover {
  color: rgba(148, 75, 216, 0.842);
} */
.mobile_nav {
  width: 100%;
  padding: 13px 16px;
  background: #fff;
  box-shadow: 0px -1px 0px 0px #e8ecfc inset;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  position: relative;

}
.mask {
  z-index: 9999999999999999;
  background: rgba(0,0,0,0.40);
  width: 100px;
  height: 300px;
}
.m_logo {
  width: 85px;
  height: 22px;
  padding-top: 0 !important;
}
.phone {
  min-width: 135px;
  height: 21px; 
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.phone-icon {
  width: 22px;
  height: 21px;
  margin-right: 5px;
}
.phone-icon img {
  width: 100%;
  height: 100%;
}
.phone-number {
  min-width: 105px;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #112166;
  line-height: 21px;
  
}
.phone-number a {
    color: #112166;
  }
.m_menu {
  width: 15%;
  display: flex;
  justify-content: space-between;
}
.m_menu img:first-child {
  width: 18px;
  height: 16px;
}
.m_menu img:last-child {
  width: 17px;
  height: 17px;
}
.m_logo img {
  max-width: 100%;
  height: auto;
  display: inline-block;
}
.menu_cont {
  width: 100%;
  position: absolute;
  text-align: left;
  left: 0;
  top: 50px;
  background: #fff;
  z-index: 9999;
}
.menuChildStyle {
  width: 100%;
  padding: 0 16px;
  height: 50px;
  box-shadow: 0px -1px 0px 0px #e8ecfc inset;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menuChildStyle h4 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: left;
  color: #1e203c;
}
.menuChildStyleSecend {
  background: #fff;
}
.menuChildStyleSecend li {
  width: calc(100% - 64px);
  margin-left: 32px;
}
.menuChildStyleSecend li a {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  text-align: left;
  color: #1e203c;
}
.menuChildStyleSecend_show {
  display: block;
}
.menuChildStyleSecend_close {
  display: none;
}
.menu_cont_show {
  display: block;
}
.menu_cont_close {
  display: none;
}



/* 新版title */
.new-home_header_title {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
}
.new-home-tit-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.new-tit-left-logo {
  width: 171px;
  height: 45px;
  position: relative;
  margin-right: 29px;
}
.new-tit-left-logo:after {
  content: '';
  width: 1px;
  height: 36px;
  position: absolute;
  right: -10px;
  top: 5px;
  background: #CBCCD2;
}
.new-tit-left-other {
  width: 226px;
  height: 34px;
}
.new-tit-left-img {
  width: 100%;
  height: 100%;
}

.new-home-tit-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 168px;
}
.new-tit-right-phone-img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.new-tit-right-phone-img img {
  width: 100%;
  height: 100%;
}
.new-home-tit-right-text {
  font-size: 12px;
  color: #777995;
}
.new-home-tit-right-phone {
  font-size: 16px;
  font-weight: bold;
  color: #282B45;
}

























</style>
